import React, { useState, useEffect, useRef, useMemo } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./App.css";


const Dashboard = ({ userId }) => {

    const [widgets, setWidgets] = useState([]);
    const [widgetInstances, setWidgetInstances] = useState([]);
    const [apps, setApps] = useState([]);
    const [users, setUsers] = useState([]);
    const [showWidgetInstanceModal, setShowWidgetInstanceModal] = useState(false);
    const [tempWidgetInstances, setTempWidgetInstances] = useState(null);
    const [showAppsModal, setShowAppsModal] = useState(false);
    const [tempApps, setTempApps] = useState(null);
    const [isLoadingDashboard, setIsLoadingDashboard] = useState(true);
    const [isSavingWidgetInstances, setIsSavingWidgetInstances] = useState(false);
    const [isSavingApps, setIsSavingApps] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [isLoadingSearch, setIsLoadingSearch] = useState(false);
    const [showingAddWidgetModal, setShowingAddWidgetModal] = useState(false);
    const [addWidgetMenuRightPosition, setAddWidgetMenuRightPosition] = useState(0);
    const [isLoadingAddWidgetModal, setIsLoadingAddWidgetModal] = useState(false);
    const [isAddingWidgetInstace, setIsAddingWidgetInstace] = useState(null);
    const [isDeletingWidgetInstace, setIsDeletingWidgetInstance] = useState(null);
    const [systematicReviewsList, setSystematicReviewsList] = useState([]);
    const [selectedWidget, setSelectedWidget] = useState(null);
    const [chosenSystematicReview, setChosenSystematicReview] = useState(null);
    const [chosenSystematicReviewArea, setChosenSystematicReviewArea] = useState(null);
    const [instanceName, setInstanceName] = useState("");

    const [isSavingConfiguration, setIsSavingConfiguration] = useState(false);
    const [isLoadingSrs, setIsLoadingSrs] = useState(false);







 


    /* WIDGET AND WIDGET INSTANCE METHODS */



    const loadWigetsData = () => {
        setIsLoadingDashboard(true);
        // Load Widget Instances
        let p1 = new Promise((resolve, reject) => {

            let url = "/umbraco/api/Home/WidgetInstances";

            fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    // Inject custom arguments for specific widgetInstances

                    data = data.map(widgetInstance => {

                        // Add custom params
                        widgetInstance = addCustomParamsToWidgetInstace(widgetInstance);

                        // Add icons
                        widgetInstance = addIconTo(widgetInstance);

                        return widgetInstance;

                    });


                    setWidgetInstances(data);
                    resolve();

                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                    setIsLoadingDashboard(false);
                });

        });

    }


    const openWidgetInstanceModal = () => {

        // No widget instances yet but opening the add widget instance menu? Then auto open the add widget menu also
        if (widgetInstances.length == 0)
            openAddWidgetModal();

        setTempWidgetInstances(JSON.parse(JSON.stringify(widgetInstances)));
        setShowWidgetInstanceModal(true);
    };


    const cancelWidgetInstanceModal = () => {
        setTempWidgetInstances(null);
        setShowingAddWidgetModal(false);
        setShowWidgetInstanceModal(false);
    };


    const saveWidgetInstanceModal = () => {

        setIsSavingWidgetInstances(true);

        let url = "/umbraco/api/Home/InstancesList";

        let bodyObj = tempWidgetInstances.map(app => ({ ...app, Id: parseInt(app.Id) })); // convert Ids back to int

        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(bodyObj)
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((response) => {
                loadWigetsData()
                setTempWidgetInstances(null);
                setShowWidgetInstanceModal(false);
                setShowingAddWidgetModal(false);

            })
            .catch((error) => {
                console.log("Error: " + error)
            })
            .finally(() => {
                setIsSavingWidgetInstances(false);
            });

    };


    const onWidgetInstanceDragEnd = (result) => {
        if (!result.destination) return;
        setTempWidgetInstances((prev) =>
            reorder(prev, result.source.index, result.destination.index)
        );
    };


    const toggleTempWidgetInstance = (id) => {
       
        setTempWidgetInstances((prev) =>
            prev.map((w) =>
                w.Id === id ? { ...w, IsActive: !w.IsActive } : w
            )
        );
    };

    const addWidgetInstance = (widgetId) => {

        setIsSavingConfiguration(true);
        let url = "/umbraco/api/Home/WidgetInstances?widgetId=" + widgetId;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
               
                data = { ...data, Id: "" + data.Id };

                data = addCustomParamsToWidgetInstace(data);
                data = addIconTo(data);

                // Add widget to management menu
                data.Name = instanceName;
                const activeWidget = { ...data, IsActive: 1, Name: instanceName };
                setTempWidgetInstances([activeWidget, ...tempWidgetInstances]);

                const inactiveWidget = { ...data, IsActive: 0 };
                setWidgetInstances([inactiveWidget, ...widgetInstances]);


                
                data.Configurations = [
                    { WidgetInstanceId: data.Id, ConfigurationId: 1, Field: "Systematic Review", Value: chosenSystematicReview },
                ];

                let url = "/umbraco/api/Home/WidgetInstances/";

                const requestOptions = {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data)
                };

                fetch(url, requestOptions)
                    .then((response) => {
                        if (!response.ok) {
                            if (response.status === 401)
                                document.dispatchEvent(new Event("api:unauthorized"));

                            throw new Error("Network response was not ok");
                        }
                        return response.json();
                    })
                    .then((response) => {

                    })
                    .catch((error) => {
                        console.log("Error: " + error)
                    })
                    .finally(() => {
                        setIsSavingConfiguration(false);

                    });

            })
            .catch((error) => {
                console.log("Error: ", error);
                setIsSavingConfiguration(false);
            });


    };



    const chooseSystematicReview = (srId) => {

        setChosenSystematicReview(srId);

        let defaultInstanceName = "Individual Review";

        if (chosenSystematicReviewArea == 1) defaultInstanceName = "Literature Review";
        if (chosenSystematicReviewArea == 2) defaultInstanceName = "Regulatory Intelligence";
        if (chosenSystematicReviewArea == 3) defaultInstanceName = "Market & PMS Review";
        setInstanceName(defaultInstanceName + ": " + systematicReviewsList.find(sr => sr.Id == srId)?.Title ?? defaultInstanceName);
    };


    const addCustomParamsToWidgetInstace = (widgetInstance) => {


        // Change all ids to string because dragable needs string Ids...
        widgetInstance = { ...widgetInstance, Id: "" + widgetInstance.Id };

        // Add widgetInstanceId in the params for all
        widgetInstance = { ...widgetInstance, params: { widgetInstanceId: widgetInstance.Id } };


        if (widgetInstance.CodeName == "literaturereviews") widgetInstance = { ...widgetInstance, params: { ...widgetInstance.params, area: 1 } };
        if (widgetInstance.CodeName == "regintelligence") widgetInstance = { ...widgetInstance, params: { ...widgetInstance.params, area: 2 } };
        if (widgetInstance.CodeName == "marketpmsvigilance") widgetInstance = { ...widgetInstance, params: { ...widgetInstance.params, area: 3 } };
        if (widgetInstance.CodeName == "taskmanager") widgetInstance = { ...widgetInstance, params: { ...widgetInstance.params, isCompany: false } };
        if (widgetInstance.CodeName == "companytaskmanager") widgetInstance = { ...widgetInstance, params: { ...widgetInstance.params, isCompany: true } };
        if (widgetInstance.CodeName == "systematicreviewdetailsliterature") widgetInstance = { ...widgetInstance, params: { ...widgetInstance.params, area: 1 } };
        if (widgetInstance.CodeName == "systematicreviewdetailsregulatory") widgetInstance = { ...widgetInstance, params: { ...widgetInstance.params, area: 2 } };
        if (widgetInstance.CodeName == "systematicreviewdetailsmarketpms") widgetInstance = { ...widgetInstance, params: { ...widgetInstance.params, area: 3 } };



        return widgetInstance;
    };


    const deleteWidgetInstance = (widgetInstanceId) => {

        setIsDeletingWidgetInstance(widgetInstanceId);

        
        // Remove from the config list
        let newTempWidgetInstances = tempWidgetInstances.filter(instance => instance.Id != widgetInstanceId);
        setTempWidgetInstances(newTempWidgetInstances);


        // Removed all widget instances? Then load the widget list if not already there
        if (newTempWidgetInstances.length == 0 && widgets.length == 0)
            openAddWidgetModal();
        setIsDeletingWidgetInstance(null);

    }


    const openAddWidgetModal = () => {


        setShowingAddWidgetModal(true);

        if (widgets.length == 0) {

            setIsLoadingAddWidgetModal(true);

            // Load widgets

            let url = "/umbraco/api/Home/Widgets";

            fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    // Order widgets by name
                    data.sort((a, b) => a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()));

                    // Add icons
                    data = data.map(widget => {
                        widget = addIconTo(widget);
                        return widget;
                    });

                    setWidgets(data);
                })
                .catch((error) => {
                    setShowingAddWidgetModal(false);
                    throw error;
                })
                .finally(() => {
                    setIsLoadingAddWidgetModal(false);
                });

        }
    };

    const loadSRs = (area) => {
        if (!area || area === "" || area === 0) {
            return;
        }

        let url = "/umbraco/api/SystematicReviewApi/SystematicReviewsAll?area=" + area;

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingSrs(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }

                return response.json();
            })
            .then((response) => {
                response.sort((a, b) => a.Title.toLowerCase().localeCompare(b.Title.toLowerCase()));
                setSystematicReviewsList(response);
            })
            .catch((error) => console.log("Error: " + error))
            .finally(() => setIsLoadingSrs(false));
    };


    const openSystematicReviewModal = (widgetInstance) => {
        setSelectedWidget(widgetInstance);
        let area = null;
        if (widgetInstance.CodeName === "systematicreviewdetailsliterature") area = 1;
        if (widgetInstance.CodeName === "systematicreviewdetailsregulatory") area = 2;
        if (widgetInstance.CodeName === "systematicreviewdetailsmarketpms") area = 3;

        setChosenSystematicReviewArea(area);
        loadSRs(area);
    };
    /* APPS METHODS */

    const openAppsModal = () => {
        setTempApps(JSON.parse(JSON.stringify(apps)));
        setShowAppsModal(true);
    };


    const cancelAppsModal = () => {
        setTempApps(null);
        setShowAppsModal(false);
    };


    const saveAppsModal = () => {

        setIsSavingApps(true);

        let url = "/umbraco/api/Home/Apps";

        let bodyObj = tempApps.filter(app => app.IsActive).map(app => ({ ...app, Id: parseInt(app.Id) })); // Send only actives and convert Ids back to int

        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(bodyObj)
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((response) => {

                setApps(tempApps);
                setTempApps(null);
                setShowAppsModal(false);

            })
            .catch((error) => {
                console.log("Error: " + error)
            })
            .finally(() => {
                setIsSavingApps(false);
            });

    };


    const onAppsDragEnd = (result) => {
        if (!result.destination) return;
        setTempApps((prev) =>
            reorder(prev, result.source.index, result.destination.index)
        );
    };


    const toggleTempApp = (id) => {
        setTempApps((prev) =>
            prev.map((a) =>
                a.Id === id ? { ...a, IsActive: !a.IsActive } : a
            )
        );
    };




    /* GENERAL METHOD */


    const handleSearchFieldKeyDown = (e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // prevent form submission if inside <form>
            submitSearchField();
          setValue(""); // clear after submit (optional)
        }
    };


    const submitSearchField = () => {

        let search = searchQuery;

        window.location = "/search-explore/medboard-search/?q=" + search;
        setIsLoadingSearch(true);
    }


    const addIconTo = (item) => {

        switch (item.CodeName) {

            case "newsfeed": item.Icon = "icon-feed"; break;
            case "regintelligence": item.Icon = "fas fa-file-signature"; break;
            case "literaturereviews": item.Icon = "fas fa-file-signature"; break;
            case "marketpmsvigilance": item.Icon = "fas fa-file-signature"; break;
            case "taskmanager": item.Icon = "far fa-calendar-check"; break;
            case "referencemanager": item.Icon = "fas fa-book-open"; break;
            case "compliancemanager": item.Icon = "fas fa-shield-alt"; break;
            case "submissions": item.Icon = "fas fa-file-import"; break;
            case "favorites": item.Icon = "far fa-star"; break;
            case "products": item.Icon = "fas fa-box-open"; break;
            case "countryregistrations": item.Icon = "fas fa-globe-americas"; break;
            case "companytaskmanager": item.Icon = "far fa-calendar-check"; break;
            case "srgroups": item.Icon = "fas fa-layer-group"; break;

            case "systematicreviewdetailsliterature": item.Icon = "fas fa-file-signature"; break;
            case "systematicreviewdetailsregulatory": item.Icon = "fas fa-file-signature"; break;
            case "systematicreviewdetailsmarketpms": item.Icon = "fas fa-file-signature"; break;

            default: break;
        }

        return item;

    }


    useEffect(() => {

        try {

            setIsLoadingDashboard(true);

            // Load Widget Instances
            let p1 = new Promise((resolve, reject) => {

                let url = "/umbraco/api/Home/WidgetInstances";

                fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    // Inject custom arguments for specific widgetInstances

                    data = data.map(widgetInstance => {

                        // Add custom params
                        widgetInstance = addCustomParamsToWidgetInstace(widgetInstance);

                        // Add icons
                        widgetInstance = addIconTo(widgetInstance);

                        return widgetInstance;

                    });


                    setWidgetInstances(data);
                    resolve();

                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                });

            });


            // Load Apps
            let p2 = new Promise((resolve, reject) => {

                let url = "/umbraco/api/Home/Apps";

                fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    data = data.map(app => ({ ...app, Id: "" + app.Id })); // dragable needs string Ids...

                    setApps(data);
                    resolve();

                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                });

            });


            // Load company users
            let p3 = new Promise((resolve, reject) => {

                let url = "/umbraco/api/TaskManagerApi/Users";

                fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    data = data.map(user => user.Id == userId ? { ...user, IsItMe: true } : user);

                    setUsers(data);
                    resolve();

                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                });

            });


            Promise.all([p1, p2, p3]).then(() => {
                setIsLoadingDashboard(false);
            });

        }
        catch (ex) {
            console.log(ex);
        }


    }, []);




    



    const widgetMap = {
        newsfeed: Newsfeed,
        literaturereviews: SystematicReviews,
        regintelligence: SystematicReviews,
        marketpmsvigilance: SystematicReviews,
        taskmanager: TaskManager,
        companytaskmanager: TaskManager,
        submissions: Submissions,
        referencemanager: ReferenceManager,
        compliancemanager: ComplianceManager,
        favorites: Favorites,
        products: Products,
        countryregistrations: CountryRegistrations,
        srgroups: SRGroups,
        systematicreviewdetailsliterature: SystematicReviewDetails,
        systematicreviewdetailsregulatory: SystematicReviewDetails,
        systematicreviewdetailsmarketpms: SystematicReviewDetails,
    };



    const content = () => {

        try {

            return (
                <div style={styles.page}>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "40px", marginBottom: "50px" }}>
                        <img
                            src="https://app.medboard.com/media/cbaew04v/logo.svg"
                            alt="Medboard Logo"
                            style={{ maxHeight: "48px", minHeight: "10px" }}
                        />
                    </div>
                    <div style={{ textAlign: "center", marginBottom: "40px" }}>
                        <i className="fas fa-globe-europe" style={{ paddingRight: "5px"}}></i>
                        <span style={{ paddingRight: "15px" }}>Explore Global Databases:</span>
                        <a className="explore-database-button" href="/content/regulatory/menu/">Regulatory</a>
                        <a className="explore-database-button" href="/content/standards/menu/">Standards</a>
                        <a className="explore-database-button" href="/content/clinical/menu/">Clinical</a>
                        <a className="explore-database-button" href="/content/market/menu/">Vigilance</a>
                        <a className="explore-database-button" href="/content/market/menu/">Market</a>
                    </div>

                    <div className="sui-search-box" style={{ display: "flex", justifyContent: "center", marginBottom: "20px", marginLeft: "20px", alignItems: "center" }}>
                        <div className="input-group u-shadow-v21 rounded g-brd-style-solid g-brd-1 g-brd-gray-light-v3" style={{ maxWidth: "800px" }}>
                            <input aria-autocomplete="list" aria-labelledby="downshift-0-label" autocomplete="off" id="downshift-0-input"
                                data-transaction-name="search input" placeholder="Search"
                                className="sui-search-box__text-input form-control form-control-md g-brd-white g-font-size-14 border-right-0 pr-0"
                                value={searchQuery} style={{ padding: "1.2rem 1.5rem 1.0rem" }} onChange={(e) => setSearchQuery(e.target.value)} onKeyDown={handleSearchFieldKeyDown} />

                            <div className="input-group-addon d-flex align-items-center g-bg-white g-brd-white g-pa-2">
                                <button className="button sui-search-box__submit btn g-font-size-14  g-color-gray-light-v1"><i className="fa fa-search"></i></button>
                            </div>
                        </div><a className="g-color-blue--hover g-transition-0_2 u-block-hover u-shadow-v39 g-brd-around list-group-item-action text-center g-text-underline--none--hover"
                            href="/ai-assistant/" title="AI Search"
                            style={{ ...styles.appIcon, width: "35px", height: "35px", marginLeft: "20px" }}><img src="/assets/images/stars-stroke-rounded-solid.svg" className="ai-icon" /></a>
                    </div>
                    {isLoadingDashboard ?
                        <div style={{display: "flex", justifyContent: "center", marginTop: "40px", gap: "10px"}}>
                            <LoadingSpinnerImage /> Loading your dashboard...
                        </div>
                    :
                        <>
                           





                        {/* Top app bar */}
                        <div style={styles.appBar}>

                            {apps.filter(a => a.IsActive).length == 0 ? <>

                                    <div style={{ textAlign: "center", marginRight: "5px", marginLeft: "5px" }}>
                                        <button onClick={openAppsModal}
                                            style={{ ...styles.appIcon, border: "2px dashed rgb(188, 188, 188)", backgroundColor: "rgb(242, 242, 242)"}}
                                            aria-label="Add new app"
                                            title="Add new app" className="g-color-blue--hover g-transition-0_2 u-block-hover g-brd-blue--hover list-group-item-action text-center g-text-underline--none--hover"
                                        >
                                            <i style={{ fontSize: "25px" }} className="fas fa-plus"></i></button>
                                        <p className="" style={{ marginTop: "8px", fontSize: "10px", fontWeight: "600" }} >Add your Favorite Apps</p>
                                    </div>

                            </> : <>
                                {apps.filter((a) => a.IsActive).map((a, index) => (
                                    <div key={index} style={{ textAlign: "center", marginRight: "5px", marginLeft: "5px", width: "80px" }}><a key={a.Id} className="g-color-blue--hover g-transition-0_2 u-block-hover u-shadow-v39 g-brd-around list-group-item-action text-center g-text-underline--none--hover"
                                        href={a.Url} style={{ ...styles.appIcon }} title={a.Name}>
                                        <i style={{ fontSize: "25px" }} className={a.Icon}></i></a>
                                        <p className="" style={{ marginTop: "8px", fontSize:"10px", fontWeight:"600" }} >{a.Name}</p>
                                    </div>
                                ))}
                                        <div style={{ textAlign: "center", marginRight: "5px", marginLeft: "5px" , width: "80px" }}>
                                            <button onClick={openAppsModal}
                                                style={{ ...styles.appIcon }}
                                                aria-label="Manage apps"
                                                title="Manage apps" className="g-color-blue--hover g-transition-0_2 u-block-hover u-shadow-v39 g-brd-around list-group-item-action text-center  g-text-underline--none--hover"
                                           >
                                                <i style={{ fontSize: "25px" }} className="fas fa-ellipsis-h"></i></button>
                                            <p className="" style={{ marginTop: "8px", fontSize: "10px", fontWeight: "600" }} >More</p>
                                        </div>
                            </>}


                        </div>





                        {/* Personalize widgetInstances button */}
                        {widgetInstances.filter(w => w.IsActive).length == 0 ? null : <>
                            <div style={{ textAlign: "right", position: "relative" }}>
                                {/*<button id="addWidgetButton" style={styles.btn} onClick={openAddWidgetModal} style={{ marginBottom: "15px", marginTop: "15px", border: "1px solid #dadada", borderRadius: "15px", padding: "0px 8px" }}>
                                    <i className="fas fa-plus-circle"></i> Add Widget
                                </button>*/}
                                <button style={styles.btn} onClick={openWidgetInstanceModal} style={{ marginBottom: "15px", marginTop: "15px", border: "1px solid #dadada", borderRadius: "15px", padding: "0px 8px" }}>
                                    ⚙️ Manage Dashboard
                                </button>



                                {/* Add widget modal */}
                                {/*
                                {showingAddWidgetModal ? <>
                                    <div style={{ right: addWidgetMenuRightPosition, position: "absolute", padding: "3px 10px", border: "1px solid #c0c0c0", borderRadius: "15px", top: "40px" }}>
                                        {isLoadingAddWidgetModal ? <div style={{alignText: "center"}}><LoadingSpinnerImage /></div> : <>
                                            {widgets.map(widget => (
                                                <div className="" onClick={() => addWidgetInstance(widget.Id)}>{widget.Name}</div>
                                            ))}
                                        </>}
                                    </div>
                                </> : null}
                                */}

                            </div>
                        </>}



                        





                        {/* Dashboard layout */}

                        {widgetInstances.filter(w => w.IsActive).length == 0 ? <>

                            <div style={{ display: "flex", justifyContent: "center", marginTop: "60px", fontWeight: "400" }}>
                                <div className="g-color-blue--hover g-transition-0_2 u-block-hover list-group-item-action text-center g-text-underline--none--hover g-brd-blue--hover"
                                    onClick={openWidgetInstanceModal} style={{ border: "2px dashed #bcbcbc", padding: "20px 8px", color:"#585f69", backgroundColor: "#f2f2f2", width: "700px", textAlign: "center", borderRadius: "15px", cursor: "pointer" }}>
                                    <span>You can customize your MedBoard Home Dashboard!</span>
                                    <br />
                                    <br />
                                    <div style={{ textAlign: "center", marginRight: "5px", marginLeft: "5px" }}>
                                        <span 
                                        
                                            aria-label="Add Widget"
                                            title="Add Widget" className="text-center"
                                        >
                                            <i style={{ fontSize: "30px" }} className="fas fa-plus"></i></span>
                                        <p className="ellipsis" style={{ marginTop: "8px" }} ></p>
                                    </div>
                              
                                </div>
                            </div>

                        </> : <>

                            <div style={styles.twoCols}>
                                <div style={styles.col}>
                                    {widgetInstances
                                        .filter((w) => w.IsActive)
                                        .filter((_, index) => index % 2 === 0)
                                        .map((w) => {

                                            if (!widgetMap[w.CodeName])
                                                return <></>

                                            return (
                                                <div key={w.Id}>{React.createElement(widgetMap[w.CodeName], { users: users, widgetInstances: widgetInstances, setWidgetInstances: setWidgetInstances, ...w.params })}</div>
                                            )
                                        }
                                    )}
                                </div>

                                <div style={styles.col}>
                                    {widgetInstances
                                        .filter((w) => w.IsActive)
                                        .filter((_, index) => index % 2 === 1)
                                        .map((w) => {

                                            if (!widgetMap[w.CodeName])
                                                return <></>

                                            return (
                                                <div key={w.Id}>{React.createElement(widgetMap[w.CodeName], { users: users, widgetInstances: widgetInstances, setWidgetInstances: setWidgetInstances, ...w.params })}</div>
                                            )
                                        }
                                    )}
                                </div>
                            </div>

                        </>}








                        {/* Widgets modal */}
                        {showWidgetInstanceModal && tempWidgetInstances && (
                            <div style={styles.modalOverlay} onMouseDown={cancelWidgetInstanceModal}>
                                <div
                                    style={styles.modal}
                                    onMouseDown={(e) => e.stopPropagation()}
                                >
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        <h3>Manage Dashboard</h3>
                                        
                                    </div>
                                    
                                        <div style={{ flex: 1, textAlign: "center" , margin: "22px"}}>
                                            {!showingAddWidgetModal ?
                                                <span className="add-task-button" onClick={() => openAddWidgetModal()} title="Add widget" style={{ color: "#f7f7f7", cursor: "pointer", padding: "8px 10px" }} ><i className="fas fa-plus-circle g-mr-5"></i>Add widget</span>
                                                : null}
                                        </div>
                                    {(tempWidgetInstances.length == 0 || showingAddWidgetModal) ? <>

                                        <div>
                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "15px", fontSize: "11px" }}>
                                                <h6>Add additional widgets</h6>
                                            </div>

                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", marginBottom: "30px" }}>

                                                <div style={{maxHeight: "150px", overflow: "auto", width: "80%", backgroundColor: "#eee", borderRadius: "10px", border: "1px solid #ccc", padding: "4px 3px"}}>
                                                        <>
                                                            {isLoadingAddWidgetModal ? (
                                                                <div style={{ textAlign: "center" }}><LoadingSpinnerImage /></div>
                                                            ) : (
                                                                widgets.map(widget => (
                                                                    <div className="lineAddWidget" style={{ display: "flex", flexDirection: "row", padding: "4px 12px" }} key={widget.Id}>
                                                                        <div style={{ flex: 1 }}>
                                                                            <i className={widget.Icon} style={{ paddingRight: "5px" }}></i>{widget.Name}
                                                                        </div>
                                                                        <div style={{ width: "70px", textAlign: "right" }}>
                                                                            {isAddingWidgetInstace === widget.Id ? (
                                                                                <LoadingSpinnerImage />
                                                                            ) : (
                                                                                <span className="addWidgetButton" onClick={() => openSystematicReviewModal(widget)}>Add</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            )}

                                                            {selectedWidget && (
                                                                <div
                                                                    className="popupOverlay"
                                                                    style={{
                                                                        position: "fixed",
                                                                        top: 0,
                                                                        left: 0,
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        backgroundColor: "rgba(0,0,0,0.5)",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        zIndex: 9999,
                                                                    }} onClick={() => {
                                                                        setSelectedWidget(null);
                                                                        setChosenSystematicReview("");
                                                                    }}

                                                                >
                                                                    <div
                                                                        className="popupContent"
                                                                        style={{
                                                                            background: "#fff",
                                                                            borderRadius: "8px",
                                                                            padding: "25px",
                                                                            width: "500px",
                                                                            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                                                                        }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        <div style={{ display: "flex", marginBottom: "20px" }}>
                                                                            <div style={{ width: "10%" }}></div>
                                                                            <div style={{ flex: 1, textAlign: "center" }}>
                                                                                <h6>Add Individual Review Widget</h6>
                                                                            </div>
                                                                            <div style={{ width: "10%", textAlign: "right" }}>
                                                                                <button
                                                                                    className="close-button"
                                                                                    onClick={() => {
                                                                                        setSelectedWidget(null);
                                                                                        setChosenSystematicReview("");
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-times"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        <div style={{ marginBottom: "15px", display: "flex", flexDirection: "row" }}>
                                                                            <div style={{ width: "35%", textAlign: "right" }}>Choose the systematic review:</div>
                                                                            <div style={{ flex: 1, marginLeft: "15px" }}>
                                                                                {isLoadingSrs ? (
                                                                                    <LoadingSpinnerImage />
                                                                                ) : (
                                                                                    <select
                                                                                        style={{ maxWidth: "200px" }}
                                                                                        value={chosenSystematicReview}
                                                                                            onChange={(e) => {
                                                                                                chooseSystematicReview(e.target.value);
                                                                                            }}
                                                                                    >
                                                                                        <option value="">Choose a Systematic Review</option>
                                                                                        {systematicReviewsList.map((sr) => (
                                                                                            <option value={sr.Id} key={sr.Id}>
                                                                                                {sr.Title} ({sr.Alias})
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                                                                            {isSavingConfiguration ? (
                                                                                <LoadingSpinnerImage />
                                                                            ) : (
                                                                                <button
                                                                                        onClick={() => {
                                                                                            if (!chosenSystematicReview) return alert("Please choose a systematic review.");
                                                                                            addWidgetInstance(selectedWidget.Id);
                                                                                            setSelectedWidget(null);
                                                                                            setChosenSystematicReview("");
                                                                                    }}
                                                                                    className="action-button save-button"
                                                                                >
                                                                                    Save
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                </div>
                                            </div>
                                        </div>

                                    </> : null}


                                       



                                    {widgetInstances.length == 0 ? 
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <span style={{color: "#c0c0c0"}}>You don't have any widget in the dashboard yet...</span>
                                        </div>
                                    : null}


                                    <DragDropContext onDragEnd={onWidgetInstanceDragEnd}>

                                        <Droppable droppableId="widgetInstances">
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 8,
                                                        height: "47vh",
                                                        maxHeight: "50vh",
                                                        overflowY: "auto",
                                                        marginTop: 12,
                                                        marginBottom: 12,
                                                        paddingRight: 4,        // small padding so scrollbar doesn't overlap
                                                    }}
                                                    >

                                                        <div style={{textAlign: "center"} }>{isSavingConfiguration ? <LoadingSpinnerImage /> : <div />}</div>

                                                    {tempWidgetInstances.map((w, index) => (
                                                        <Draggable key={w.Id} draggableId={w.Id} index={index}>
                                                            {(provided) => (
                                                                
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        border: "1px solid #ddd",
                                                                        borderRadius: 8,
                                                                        background: "#fafafa",
                                                                        ...provided.draggableProps.style,
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                                                            <span {...provided.dragHandleProps} style={{ cursor: "grab" }}>
                                                                                ☰
                                                                            </span>
                                                                            
                                                                            <div style={{ display: "flex", alignItems: "center", gap: "15px", flex: 1, marginLeft: "25px" }}>
                                                                                <span title={w.Name}>
                                                                                    <i className={w.Icon} style={{ paddingRight: "5px" }}></i>
                                                                                    {w.Name.length > 100 ? `${w.Name.slice(0, 100)}(...)` : w.Name}
                                                                                </span>

                                                                            </div>

                                                                            <div>
                                                                                {isDeletingWidgetInstace == w.Id ? 
                                                                                    <LoadingSpinnerImage />
                                                                                :
                                                                                    <>
                                                                                        <input
                                                                                            title="Visible in dashboard"
                                                                                            type="checkbox"
                                                                                            checked={w.IsActive}
                                                                                            onChange={async () => {
                                                                                                toggleTempWidgetInstance(w.Id);
                                                                                            }}
                                                                                        />
                                                                            
                                                                                        {[12, 15, 16].includes(w.WidgetId) && (
                                                                                            <span
                                                                                                title="Delete"
                                                                                                onClick={() => deleteWidgetInstance(w.Id)}
                                                                                                style={{ marginLeft: "15px", cursor: "pointer" }}
                                                                                            >
                                                                                                <i className="fas fa-times-circle"></i>
                                                                                            </span>
                                                                                        )}
                                                                                    </>
                                                                            }
                                                                            </div>

                                                                        </div>
                                                                      
                                                                    </div>


                                                                </div>
                                                                
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>

                                    </DragDropContext>


                                    <div style={styles.controlRow}>
                                        <button style={styles.btn} onClick={cancelWidgetInstanceModal}>
                                            Cancel
                                        </button>
                                        {isSavingWidgetInstances ? <div><LoadingSpinnerImage /></div> :
                                            <button style={styles.btnPrimary} onClick={saveWidgetInstanceModal}>
                                                Save
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        )}





                        {/* Apps modal */}
                        {showAppsModal && tempApps && (
                            <div style={styles.modalOverlay} onMouseDown={cancelAppsModal}>
                                <div
                                    style={styles.modal}
                                    onMouseDown={(e) => e.stopPropagation()}
                                >
                                    <h3>Manage Apps</h3>

                                    <DragDropContext onDragEnd={onAppsDragEnd}>
                                        <Droppable droppableId="apps">
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.droppableProps}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 8,
                                                        maxHeight: "50vh",
                                                        overflowY: "auto",
                                                        marginTop: 12,
                                                        marginBottom: 12,
                                                        paddingRight: 4
                                                    }}
                                                >
                                                    {tempApps.map((a, index) => (
                                                        <Draggable key={a.Id} draggableId={a.Id} index={index}>
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        padding: "8px 12px",
                                                                        border: "1px solid #ddd",
                                                                        borderRadius: 8,
                                                                        background: "#fafafa",
                                                                        ...provided.draggableProps.style,
                                                                    }}
                                                                >
                                                          
                                                                    <span {...provided.dragHandleProps} style={{ cursor: "grab", marginRight:"12px" }}>
                                                                        ☰
                                                                    </span>
                                                                    <div style={{display: "flex", alignItems: "center", gap: "15px", flex: 1, marginLeft: "50px"}}>
                                                                    <span className={a.Icon}></span>
                                                                        <span className="ellipsis">{a.Name}</span>
                                                                    </div>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={a.IsActive}
                                                                        onChange={() => toggleTempApp(a.Id)}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>


                                    <div style={styles.controlRow}>
                                        <button style={styles.btn} onClick={cancelAppsModal}>
                                            Cancel
                                        </button>
                                        {isSavingApps ? <div><LoadingSpinnerImage /></div> :
                                            <button style={styles.btnPrimary} onClick={saveAppsModal}>
                                                Save
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        )}




                    </>}




                </div>
            );

        }
        catch (ex) {
            console.log(ex)
            return (<>

                <div>There was an error loading you dashboard...</div>

            </>);
        }

    }






    return (<>
        {content()}
    </>);

};






const Box = ({ children }) => (
    <div
        style={{
            padding: 16,
            borderRadius: 12,
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        }}
    >
        {children}
    </div>
);





/**
 * 
 * WIDGETS WIDGETS WIDGETS WIDGETS 
 * WIDGETS WIDGETS WIDGETS WIDGETS 
 * WIDGETS WIDGETS WIDGETS WIDGETS 
 * WIDGETS WIDGETS WIDGETS WIDGETS 
 * 
 */



const Newsfeed = ({ widgetInstanceId, widgetInstances }) => {

    const [news, setNews] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState(null);

    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;

    useEffect(() => {

        try {

            setIsLoading(true);

            let url = "/umbraco/api/Home/NewsFeedWidget?widgetInstanceId=" + widgetInstanceId;

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    setModuleUrl(response.ModuleUrl);
                    setNews(response.News);
                    setIsLoading(false);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                });

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);




    
    const content = () => {

        try {
            return (<>
                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i> News Feed
                    </div>
                </div>

                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                    {error ? <div>{error}</div> : <>

                        {/*
                        <div>
                            <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                <div style={{ width: "60%" }}>NEWS</div>
                                <div style={{ width: "15%" }}>DATE</div>
                                <div style={{ width: "25%" }}>AUTHORITY</div>
                            </div>
                            {news.map((news) => (
                                <div className="widgetDataLine" style={{display: "flex", flexDirection: "row", }}>
                                    <div style={{ width: "60%" }}><a href={news.Url}>{news.Title}</a></div>
                                    <div style={{ width: "15%" }}>{formatDate(news.Date)}</div>
                                    <div style={{ width: "25%" }}><img src={news.Image} style={{width: "20px"}} /> {news.Authority}</div>
                                </div>
                            ))}
                        </div>
                        */}

                            <div style={{ maxHeight: "300px", overflow: "auto" }}>

                                <ul className="news-feed list-unstyled" style={{ marginTop: "12px" }} >
                                    {news.map((news, index) => (
                                        <li key={index} className="news-feed-item media g-brd-around g-brd-gray-light-v4 g-brd-left-3 g-brd-gray-left g-rounded-15 overflow-hidden g-pa-10 g-mb-7 g-bg-white">

                                            <div className="media-body">
                                                <div className="d-flex justify-content-between">
                                                    <p className="g-font-weight-600 g-color-black">
                                                        <img src={news.Image} alt="" width="21" />
                                                        <a href={news.ProfileUrl} target="_blank" style={{ marginLeft: "10px", fontSize: "14px" }}>{news.Authority}</a>
                                                    </p>
                                                </div>

                                                <p>{news.Type.replace(' &bull;','')} · {formatDate(news.Date)}</p>

                                                <div className="row">
                                                    <div className="col-12 col-lg-10">
                                                        <p>
                                                            <a target="_blank" style={{ fontSize: "13px", color: "#385898" }} href={news.Url}>
                                                                {news.Authority == "MedBoard" ? <div dangerouslySetInnerHTML={{ __html: news.Title }}></div> : <>{news.Title}</>}
                                                                <span style={{ fontSize: "10px", marginLeft: "10px" }} className="fas fa-external-link-alt"></span>
                                                            </a>
                                                        </p>
                                                    </div>
                                                    {news.MediaPath && (
                                                        <div className="col-12 col-lg-2">
                                                            <a target="_blank" href={news.MediaPath}>
                                                                <span className="fas fa-file-pdf g-font-size-18"></span>
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                
                            </div><div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={moduleUrl} className="widget-view-all-button">Open</a></div>





                    </>}


                </>}

            </>)
        }
        catch (ex) {
            return (<>
                <div className="widgetTitle"><i className="icon-feed g-mr-8"></i> News Feed</div>
                <ErrorMessage />
            </>)
        }

    }




    return (
        <Box>
            {content()}
        </Box>
    );
};



const SystematicReviews = ({ widgetInstanceId, area, widgetInstances }) => {

    const [srs, setSrs] = useState([]);
    const [widgetTitle, setWidgetTitle] = useState("Systematic Reviews");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState(null);

    
    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;


    useEffect(() => {

        try {

            switch (area) {
                case 1: setWidgetTitle("Literature Reviews"); break;
                case 2: setWidgetTitle("Regulatory Intelligence"); break;
                case 3: setWidgetTitle("Market & PMS Vigilance"); break;
                default: break;
            };

            setIsLoading(true);

            let url = "";

            if(area == 1) url = "/umbraco/api/Home/LiteratureReviewsWidget";
            if(area == 2) url = "/umbraco/api/Home/RegulatoryIntelligenceWidget";
            if(area == 3) url = "/umbraco/api/Home/MarketPMSWidget";

            url += "?widgetInstanceId=" + widgetInstanceId;

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    setModuleUrl(response.ModuleUrl);
                    setSrs(response.Surveillances);
                    setIsLoading(false);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                });

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);



    
    const content = () => {

        try {
            return (<>
                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i> {widgetTitle}
                    </div>
                    <div style={{width: "120px"}}>
                        <span title="Showing the latest reviews where you are responsible or collaborator" className="assigned-to-only pull-right"><i className="far fa-user g-font-size-10 g-mr-5"></i>My Reviews</span>
                    </div>
                </div>


                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                    {error ? <div>{error}</div> : <>

                        <div>
                            <div style={{ display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada" }}>
                                <div style={{ width: "50%" }}>TITLE</div>
                                <div style={{ width: "25%" }}>PENDING</div>
                                    <div style={{ width: "25%" }}>{area == 1 ? "LAST MODIFIED" : "LAST MATCH"}</div>
                            </div>
                                {srs.map((sr) => (
                                    <div
                                        key={sr.Id}
                                        className="widgetDataLine"
                                        style={{ display: "flex", flexDirection: "row" }}
                                    >
                                        <div style={{ width: "50%" }}>
                                            <a href={sr.Url}>{sr.Title}</a>
                                        </div>
                                        <div style={{ width: "25%" }}>
                                            <div className={`badge-pending ${sr.Pending > 0 ? "positive" : "zero"}`}>
                                                {sr.Pending}
                                            </div>
                                        </div>
                                        <div style={{ width: "25%" }}>{formatDate(area == 1 ? sr.LastDate : sr.LastMatch, false)}</div>
                                    </div>
                                ))}
                                <div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={moduleUrl} className="widget-view-all-button">Open</a></div>
                        </div>

                    </>}

                </>}

            </>)
        }
        catch (ex) {
            return (<>
                <div className="widgetTitle"><i className="fas fa-file-signature g-mr-8"></i> {widgetTitle}</div>
                <ErrorMessage />
            </>)
        }

    }



    return (
        <Box>
            {content()}
        </Box>
    );
};



const TaskManager = ({ widgetInstanceId, isCompany, widgetInstances}) => {

    const [tasks, setTasks] = useState([]);
    const [totalOpenTasks, setTotalOpenTasks] = useState(null);
    const [totalLateTasks, setTotalLateTasks] = useState(null);
    const [tasksEndingToday, setTasksEndingToday] = useState(null);
    const [tasksNext7Days, setTasksNext7Days] = useState(null);
    const [priorities, setPriorities] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState(null);


    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;

    useEffect(() => {

        try {

            setIsLoading(true);

            setPriorities([
                { id: 1, name: "High" },
                { id: 2, name: "Medium" },
                { id: 3, name: "Low" },
                { id: 4, name: "None" },
            ]);

            let url = "/umbraco/api/Home/TaskManagerWidget?widgetInstanceId=" + widgetInstanceId + "&isCompany=" + isCompany;

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    setModuleUrl(response.ModuleUrl);
                    setTasks(response.Next5Tasks);
                    setTotalOpenTasks(response.TotalOpenTasks);
                    setTotalLateTasks(response.TotalLateTasks);
                    setTasksEndingToday(response.TasksEndingToday);
                    setTasksNext7Days(response.TasksNext7Days);

                    setIsLoading(false);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                });

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);




    const getPriorityById = (id) => {
        return priorities.find((item) => item.id == id);
    };


    const Priority = ({ value, size }) => {
        let bgcolor = "";
        let color = "white";

        switch (String(value)) {
            case "1":
                bgcolor = "#d1153a";
                break;
            case "2":
                bgcolor = "#f7b204";
                break;
            case "3":
                bgcolor = "#48ca94";
                break;
            case "4":
                bgcolor = "#f0f0f0";
                color = "#333";
                break;
            default:
                break;
        }

        let padding = "5px";
        let width = "100px";

        if (size == "small") {
            padding = "2px";
            width = "70px";
        }

        return (
            <>
                <div
                    style={{
                        padding: padding,
                        borderRadius: "5px",
                        textAlign: "center",
                        color: color,
                        width: width,
                        backgroundColor: bgcolor
                    }}
                >
                    {getPriorityById(value)?.name}
                </div>
            </>
        );
    };


    
    const content = () => {

        try {
            return (<>
                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i>{isCompany == true ? "Company " : ""}Task Manager
                    </div>
                    <div style={{width: "150px"}}>
                        {isCompany == false ? <span className="assigned-to-only pull-right" title="Showing the open tasks assigned to you"><i className="far fa-user g-font-size-10 g-mr-5"></i>My Tasks</span> : null }
                        {isCompany == true ? <span className="assigned-to-only pull-right" title="Showing the open tasks of the company"><i className="far fa-user g-font-size-10 g-mr-5"></i>Company Tasks</span> : null }
                    </div>
                </div>


                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                        {error ? <div>{error}</div> : <>

                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-evenly"}}>
                                <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{totalOpenTasks}</span><br /><i className="fas fa-circle" style={{ textAlign: "center", fontSize: "6pt", marginRight: "8px", color:"#abb8c3", display: "none" }}></i><span>Open tasks</span></div>
                                <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{totalLateTasks}</span><br /><i className="fas fa-circle" style={{ textAlign: "center", fontSize: "6pt", marginRight: "8px", color: "#d1153a" }}></i><span>Late tasks</span></div>
                                <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{tasksEndingToday}</span><br /><i className="fas fa-circle" style={{ textAlign: "center", fontSize: "6pt", marginRight: "8px", color: "#92c6f9" }}></i><span>Ending today</span></div>
                                <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{tasksNext7Days}</span><br /><i className="fas fa-circle" style={{ textAlign: "center", fontSize: "6pt", marginRight: "8px", color: "#fedb83" }}></i><span>Next 7 Days</span></div>
                        </div>
                        <br/>
                        <div>
                            <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                <div style={{ width: "50%" }}>TASK</div>
                                <div style={{ width: "25%" }}>DUE DATE</div>
                                <div style={{ width: "25%" }}>PRIORITY</div>
                            </div>
                            {tasks.map((task, index) => (
                                <div key={index} className="widgetDataLine" style={{display: "flex", flexDirection: "row", }}>
                                    <div style={{ width: "50%" }}><a href={"/your-medboard/task-manager/?loadTaskByDefault=" + task.Id}>{task.Title}</a></div>
                                    <div style={{ width: "25%" }}>{formatDate(task.Date)}</div>
                                    <div style={{ width: "25%" }}><Priority value={task.Priority} size="small" /></div>
                                </div>
                            ))}<div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={moduleUrl} className="widget-view-all-button">Open</a></div>
                        </div>

                    </>}


                </>}

            </>)
        }
        catch (ex) {
            return (<>
                <div className="widgetTitle"><i className="far fa-calendar-check g-mr-8"></i>Task Manager</div>
                <ErrorMessage />
            </>)
        }

    }



    return (
        <Box>
            {content()}
        </Box>
    );
};



const Submissions = ({ widgetInstanceId, widgetInstances }) => {

    const [submissions, setSubmissions] = useState([]);
    const [totalSubmissions, setTotalSubmissions] = useState([]);
    const [newSubmissions, setNewSubmissions] = useState([]);
    const [renewalSubmissions, setRenewalSubmissions] = useState([]);
    const [changeSubmissions, setChangeSubmissions] = useState([]);
    const [otherSubmissions, setOtherSubmissions] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState(null);

    
    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;


    useEffect(() => {

        try {

            setIsLoading(true);

            let url = "/umbraco/api/Home/SubmissionsWidget?widgetInstanceId=" + widgetInstanceId;

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    setModuleUrl(response.ModuleUrl);
                    setSubmissions(response.Last5Submissions);
                    setTotalSubmissions(response.CountByType.TotalCount);
                    setNewSubmissions(response.CountByType.Counts.find(s => s.Name == "New").Count);
                    setRenewalSubmissions(response.CountByType.Counts.find(s => s.Name == "Renewal").Count);
                    setChangeSubmissions(response.CountByType.Counts.find(s => s.Name == "Change").Count);
                    setOtherSubmissions(response.CountByType.Counts.find(s => s.Name == "Other").Count);

                    setIsLoading(false);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                });

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);


    const content = () => {

        try {
            return (<>
                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i> Submissions
                    </div>
                </div>

                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                    {error ? <div>{error}</div> : <>

                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-evenly"}}>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{totalSubmissions}</span><br/><span>Open Submissions</span></div>
                                <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{newSubmissions}</span><br /><i className="fas fa-circle" style={{ textAlign: "center", fontSize: "6pt", marginRight: "8px", color: "#aef1b5" }}></i><span>New</span></div>
                                <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{renewalSubmissions}</span><br /><i className="fas fa-circle" style={{textAlign: "center", fontSize: "6pt", marginRight: "8px", color: "#99d1f6"}}></i><span>Renewal</span></div>
                                <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{changeSubmissions}</span><br /><i className="fas fa-circle" style={{ textAlign: "center", fontSize: "6pt", marginRight: "8px", color: "#ffd593"}}></i><span>Change</span></div>
                                <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{otherSubmissions}</span><br /><i className="fas fa-circle" style={{textAlign: "center", fontSize: "6pt", marginRight: "8px", color: "#e5e5e5"}}></i><span>Other</span></div>
                        </div>
                        <br/>
                        <div>
                            <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                <div style={{ width: "45%" }}>SUBMISSION NAME</div>
                                <div style={{ width: "10%" }}>DAYS OPEN</div>
                                <div style={{ width: "15%" }}>STATUS</div>
                                <div style={{ width: "15%" }}>PRIORITY</div>
                                <div style={{ width: "15%" }}>TYPE</div>
                            </div>
                            {submissions.map((submission, index) => (
                                <div key={index} className="widgetDataLine" style={{display: "flex", flexDirection: "row", }}>
                                    <div style={{ width: "45%" }}><a href={moduleUrl + "?submissionId=" + submission.Id}>{submission.Title}</a></div>
                                    <div style={{ width: "10%" }}>{submission.DaysOpened}</div>
                                    <div style={{ width: "15%" }}><FieldTypes.FieldType_Submission_Status value={submission.Status} /></div>
                                    <div style={{ width: "15%" }}><FieldTypes.FieldType_Submission_Priority value={submission.Priority} /></div>
                                    <div style={{ width: "15%" }}><FieldTypes.FieldType_Submissions_Type value={submission.Type} /></div>
                                </div>
                            ))}<div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={moduleUrl} className="widget-view-all-button">Open</a></div>
                        </div>

                    </>}


                </>}
            </>)
        }
        catch (ex) {
            return (<>
                <div className="widgetTitle"><i className="fas fa-file-import g-mr-8"></i> Submissions</div>
                <ErrorMessage />
            </>)
        }

    }


    return (
        <Box>
            {content()}
        </Box>
    );
};



const ReferenceManager = ({ widgetInstanceId, widgetInstances }) => {

    const [references, setReferences] = useState([]);
    const [totalReferences, setTotalReferences] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState(null);

    
    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;


    useEffect(() => {

        try {

            setIsLoading(true);

            let url = "/umbraco/api/Home/ReferenceManagerWidget?widgetInstanceId=" + widgetInstanceId;

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    setModuleUrl(response.ModuleUrl);
                    setReferences(response.Last5FilesAdded);
                    setTotalReferences(response.Total);

                    setIsLoading(false);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                });

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);


    const content = () => {

        try {

            return (<>
                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i> Reference Manager
                    </div>
                </div>

                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                    {error ? <div>{error}</div> : <>

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{totalReferences}</span><br /><span>References</span></div>
                        </div>
                        <br/>
                        <div>
                            <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                <div style={{ width: "60%" }}>LATEST REFERENCES ADDED</div>
                                <div style={{ width: "30%" }}>YEAR</div>
                                <div style={{ width: "10%" }}>SOURCE</div>
                            </div>
                            {references.map((reference, index) => (
                                <div key={index} className="widgetDataLine" style={{display: "flex", flexDirection: "row", }}>
                                    <div style={{ width: "60%" }}><a target="_blank" href={reference.Url}>{reference.Title}</a></div>
                                    <div style={{ width: "30%" }}>{reference.Year}</div>
                                    <div style={{ width: "10%" }}>{reference.Source}</div>
                                </div>
                            ))}<div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={moduleUrl} className="widget-view-all-button">Open</a></div>
                        </div>

                    </>}


                </>}
            </>)

        }
        catch (ex) {
            return (<>
                <div className="widgetTitle"><i className="fas fa-book-open g-mr-8"></i> Reference Manager</div>
                <ErrorMessage />
            </>)
        }


    }


    return (
        <Box>
            {content()}
        </Box>
    );
};



const ComplianceManager = ({ widgetInstanceId, widgetInstances }) => {

    const [standards, setStandards] = useState([]);
    const [regdocs, setRegDocs] = useState([]);
    const [totalStandards, setTotalStandards] = useState([]);
    const [totalRegulatoryDocuments, setTotalRegulatoryDocuments] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState(null);


    
    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;


    useEffect(() => {

        try {

            setIsLoading(true);

            let url = "/umbraco/api/Home/ComplianceManagerWidget?widgetInstanceId=" + widgetInstanceId;

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    setStandards(response.StandardsLastChanges);
                    setRegDocs(response.RegulatoryDocumentsLastChanges);
                    setTotalStandards(response.TotalStandards);
                    setTotalRegulatoryDocuments(response.TotalRegulatoryDocuments);
                    setModuleUrl(response.ModuleUrl);

                    setIsLoading(false);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                });

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);



    const content = () => {

        try {

            return (<>

                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i> Compliance Manager
                    </div>
                </div>

                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                    {error ? <div>{error}</div> : <>

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{totalRegulatoryDocuments}</span><br /><span>Regulations</span></div>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{totalStandards}</span><br /><span>Standards</span></div>
                        </div>
                        <br/>
                          
                        <div>
                            <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                <div style={{ width: "80%" }}>LATEST REGULATIONS ADDED</div>
                                <div style={{ width: "20%" }}>COUNTRY</div>
                            </div>
                            {regdocs.map((regdoc, index) => (
                                <div key={index} className="widgetDataLine" style={{display: "flex", flexDirection: "row", }}>
                                    <div style={{ width: "80%" }}>{regdoc.Title}</div>
                                    <div style={{ width: "20%" }}>{regdoc.Country}</div>
                                </div>
                            ))}
                        </div>

                          
                        <div style={{marginTop:"30px"} }>
                            <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                <div style={{ width: "80%" }}>LATEST STANDARDS ADDED</div>
                                <div style={{ width: "20%" }}>YEAR</div>
                            </div>
                            {standards.map((standard, index) => (
                                <div key={index} className="widgetDataLine" style={{display: "flex", flexDirection: "row", }}>
                                    <div style={{ width: "80%" }}>{standard.Title}</div>
                                    <div style={{ width: "20%" }}>{standard.Year}</div>
                                </div>
                            ))}<div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={moduleUrl} className="widget-view-all-button">Open</a></div>
                        </div>

                    </>}


                </>}

            </>)

            

        } catch (ex) {

            return (<>
                <div className="widgetTitle"><i className="fas fa-shield-alt g-mr-8"></i> Compliance Manager</div>
                <ErrorMessage />
            </>)

        }

    }



    return (
        <Box>
            {content()}
        </Box>
    );
};



const Favorites = ({ widgetInstanceId, widgetInstances }) => {

    const [favorites, setFavorites] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isDoingAction, setIsDoingAction] = useState(null);
    const [showingDeleteConfirm, setShowingDeleteConfirm] = useState(null);
    const [editingFavorite, setEditingFavorite] = useState(null);
    const [editingFavoriteText, setEditingFavoriteText] = useState(null);
    const [isEditingFavoriteFieldDisabled, setIsEditingFavoriteFieldDisabled] = useState(false);
    const [favoritePreviousName, setFavoritePreviousName] = useState("");
    const [errorEditingFavorite, setErrorEditingFavorite] = useState(null);

    const menuRefs = useRef({}); // store refs for each favorite id
    const moveUpFavoriteRef = useRef(null);
    const moveDownFavoriteRef = useRef(null);
    const editFavoriteRef = useRef(null);
    const removeFavoriteRef = useRef(null);
    const favoriteEditFieldRef = useRef(null);

    
    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;


    const hideHoverMenu = () => {
        setShowingDeleteConfirm(null);
    }


    const showConfirmDelete = (id) => {

        setShowingDeleteConfirm(id);

    }

    

    const removeFavorite = (id) => {

        try {

            hideHoverMenu();
            setIsDoingAction(id);

            let url = "/umbraco/api/Home/Favorites/?favoriteId=" + id;

            const requestOptions = {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.text();
                })
                .then((response) => {

                    setFavorites(favorites.filter(fav => fav.Id != id));

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                    setIsDoingAction(null);
                });

        }
        catch (ex) {

        }

    }



    const handleFavoriteEnterKey = (e, id) => {

        if (e.key == "Enter") {
            e.preventDefault();
            saveFavorite(id);
            return;
        }
    }



    const editFavorite = (id) => {

        let currentName = favorites.find(f => f.Id == id).Name;

        hideHoverMenu();
        setEditingFavoriteText(currentName);
        setFavoritePreviousName(currentName);
        setEditingFavorite(id);
        setErrorEditingFavorite(null);

        setTimeout(() => {

            const len = favoriteEditFieldRef.current.value.length;
            favoriteEditFieldRef.current.setSelectionRange(len, len);
            favoriteEditFieldRef.current.focus();

        }, 200);
    }



    const saveFavorite = (id) => {

        if (isDoingAction)
            return;

        let newName = editingFavoriteText;

        setIsDoingAction(id);
        setIsEditingFavoriteFieldDisabled(true);
        setErrorEditingFavorite(null);
        

        let url = "/Umbraco/Api/Home/Favorites?favoriteId=" + id + "&name=" + encodeURIComponent(newName);

        const requestOptions = {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((response) => {

                favorites.map(f => {
                    if (f.Id == id)
                        f.Name = newName;
                    return f;
                });

            })
            .catch((error) => {
                console.log("Error: " + error)
                setErrorEditingFavorite(id);
                
            })
            .finally(() => {
                setIsEditingFavoriteFieldDisabled(false);
                setIsDoingAction(null);
                setEditingFavorite(null);
            });

        

    }



    const moveFavorite = (id, direction) => {

        let currentIndex = favorites.findIndex(f => f.Id == id);
        let finalIndex = direction == "up" ? currentIndex - 1 : currentIndex + 1;

        // It's already first?
        if (direction == "up" && currentIndex == 0)
            return;

        // It's already last?
        if (direction == "down" && currentIndex == favorites.length - 1)
            return;


        hideHoverMenu();
        setIsDoingAction(id);
        setErrorEditingFavorite(null);

        let currentFavorite = favorites[currentIndex];
        let finalFavorite = favorites[finalIndex];


        let url = "/Umbraco/Api/Home/FavoritesSwichtOrder/?originId=" + currentFavorite.Id + "&destId=" + finalFavorite.Id;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((response) => {

                favorites[finalIndex] = currentFavorite;
                favorites[currentIndex] = finalFavorite;
                
            })
            .catch((error) => {
                console.log("Error: " + error)
                setErrorEditingFavorite(id);
            })
            .finally(() => {
                setIsDoingAction(null);
            });

    }





    function decodeHtmlEntities(str) {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    }



    useEffect(() => {

        try {

            setIsLoading(true);

            let url = "/umbraco/api/Home/FavoritesWidget?widgetInstanceId=" + widgetInstanceId;

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    setFavorites(response);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                    setIsLoading(false);
                });




            function handleClickOutside(event) {

                const optionRefs = [moveUpFavoriteRef, moveDownFavoriteRef, editFavoriteRef, removeFavoriteRef];

                // Check if click is outside all menu refs
                const clickedInsideSomeMenu = Object.values(menuRefs.current).some((ref) => ref && ref.contains(event.target));
                const clickedInOption = optionRefs.some(ref => ref.current && ref.current.contains(event.target));

                if (!clickedInsideSomeMenu && !clickedInOption) {
                    setShowingDeleteConfirm(null);
                }
            }

            document.addEventListener("mousedown", handleClickOutside);

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);




    const content = () => {

        try {

            return (<>

                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i> My Favorites
                    </div>
                </div>

                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                    {error ? <div>{error}</div> : <>

                        {favorites.length == 0 ? <>

                            <div style={{ color: "#c6c6c6", textAlign: "center" }}>
                                    <span style={{ fontSize: "12pt" }}>No favorites yet!</span>
                                    <br />
                                    <br />
                                    <span>To add favorites to this list click on the <i className="fas fa-star"></i> on the top right corner available in every page</span>
                                    <br />
                                    <br />
                            </div>

                        </> : <>
                            <div>
                                <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                    <div style={{ width: "80%" }}>PAGE</div>
                                    <div style={{ width: "20%" }}>ACTIONS</div>
                                </div>


                                {favorites.map((favorite) => (
                                    <div key={favorite.Id} className="widgetDataLine" style={{ display: "flex", flexDirection: "row" }}>
                                        <div style={{ width: "80%" }}>

                                            {editingFavorite == favorite.Id ?
                                                <input ref={favoriteEditFieldRef} disabled={isEditingFavoriteFieldDisabled} text="text" maxLength={1000} style={{ width: "100%", marginRight: "20px", padding: "0px 5px" }} value={editingFavoriteText} onChange={(e) => setEditingFavoriteText(e.target.value)} onKeyDown={(e) => handleFavoriteEnterKey(e, favorite.Id)} onBlur={(e) => saveFavorite(favorite.Id)} />
                                                : 
                                                <a href={favorite.Value}>{decodeHtmlEntities(favorite.Name)}</a>
                                            }

                                        </div>
                                        <div style={{ width: "20%", position: "relative" }}>
                                            {isDoingAction === favorite.Id ?
                                                <div><LoadingSpinnerImage /></div>
                                            :
                                                <>
                                                    <span
                                                        ref={(el) => (menuRefs.current[favorite.Id] = el)}
                                                        style={{ cursor: "pointer", padding: "6px" }}
                                                        onClick={() => showConfirmDelete(favorite.Id)}
                                                    >
                                                        <i className="fas fa-ellipsis-v"></i>
                                                    </span>

                                                    {errorEditingFavorite == favorite.Id ? 
                                                        <i className="fas fa-exclamation-triangle"></i>
                                                        : null
                                                    }
                                                </>
                                            }


                                            {showingDeleteConfirm === favorite.Id ? (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        backgroundColor: "#e6e6e6",
                                                        width: "130px",
                                                        padding: "3px 3px",
                                                        borderRadius: "10px",
                                                        top: "0px",
                                                        left: "25px",
                                                        zIndex: 99,
                                                    }}
                                                >
                                                    {favorites.findIndex(f => f.Id == favorite.Id) > 0 &&
                                                        <div ref={moveUpFavoriteRef} className="favoriteHoverMenuOption" style={{ cursor: "pointer", margin: "3px" }} onClick={() => moveFavorite(favorite.Id, "up")}>
                                                            <i className="fas fa-chevron-up"></i> Move up
                                                        </div>
                                                    }

                                                    {favorites.findIndex(f => f.Id == favorite.Id) < favorites.length - 1 &&
                                                        <div ref={moveDownFavoriteRef} className="favoriteHoverMenuOption" style={{ cursor: "pointer", margin: "3px" }} onClick={() => moveFavorite(favorite.Id, "down")}>
                                                            <i className="fas fa-chevron-down"></i> Move down
                                                        </div>
                                                    }

                                                    <div ref={editFavoriteRef} className="favoriteHoverMenuOption" style={{cursor: "pointer", margin: "3px" }} onClick={() => editFavorite(favorite.Id)}>
                                                        <i className="fas fa-pencil-alt"></i> Edit
                                                    </div>

                                                    <div ref={removeFavoriteRef} className="favoriteHoverMenuOption" style={{cursor: "pointer", margin: "3px" }} onClick={() => removeFavorite(favorite.Id)}>
                                                        <i className="far fa-trash-alt"></i> Delete
                                                    </div>
                                                </div>
                                            ) : null}

                                        </div>
                                    </div>
                                ))}





                                <br/>
                            </div>

                        </>}

                    </>}

                </>}

            </>);

        }
        catch (ex) {
            console.log("ex:" + ex)
            return (<>
                <div className="widgetTitle"><i className="far fa-star g-mr-8"></i> My Favorites</div>
                <ErrorMessage />
            </>)
        }

    }


    return (
        <Box>
            {content()}
        </Box>
    );

};



const Products = ({ widgetInstanceId, widgetInstances }) => {

    const [products, setProducts] = useState([]);
    const [productCount, setProductCount] = useState([]);
    const [familyCount, setFamilyCount] = useState([]);
                
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState(null);

    
    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;


    useEffect(() => {

        try {

            setIsLoading(true);

            let url = "/umbraco/api/Home/ProductsWidget?widgetInstanceId=" + widgetInstanceId;

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    setModuleUrl(response.ModuleUrl);
                    setProducts(response.Last5Modified);
                    setProductCount(response.ProductCount);
                    setFamilyCount(response.FamilyCount);

                    setIsLoading(false);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                });

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);


    const content = () => {

        try {

            return (<>
                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i>RIMS Products
                    </div>
                </div>

                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                    {error ? <div>{error}</div> : <>

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{productCount}</span><br /><span>Products</span></div>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{familyCount}</span><br /><span>Families</span></div>
                        </div>
                        <br/>
                        <div>
                            <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                <div style={{ width: "25%" }}>LAST MODIFIED SKUs</div>
                                <div style={{ width: "60%" }}>PRODUCT NAME</div>
                                <div style={{ width: "15%" }}>REGISTRATIONS</div>
                            </div>
                            {products.map((product, index) => (
                                <div key={index} className="widgetDataLine" style={{display: "flex", flexDirection: "row", }}>
                                    <div style={{ width: "25%" }}><a href={product.ProductUrl}>{product.SKUCode}</a></div>
                                    <div style={{ width: "60%" }}>{product.Name}</div>
                                    <div style={{ width: "15%" }}>{product.NumberOfRegistrations}</div>
                                </div>
                            ))}<div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={moduleUrl} className="widget-view-all-button">Open</a></div>
                        </div>

                    </>}

                </>}
            </>)

        }
        catch (ex) {
            return (<>
                <div className="widgetTitle"><i className="fas fa-book-open g-mr-8"></i> RIMS Products</div>
                <ErrorMessage />
            </>)
        }


    }


    return (
        <Box>
            {content()}
        </Box>
    );
};



const CountryRegistrations = ({ widgetInstanceId, widgetInstances }) => {


    const [operatorsCount, setOperatorsCount] = useState(null);
    const [countryRegistrationsCount, setCountryRegistrationsCount] = useState(null);
    const [totalCountriesWithActivity, setTotalCountriesWithActivity] = useState(null);
    const [expiredIn1YearCount, setExpiredIn1YearCount] = useState([]);
    const [expiredIn1Year, setExpiredIn1Year] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState(null);

    
    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;


    useEffect(() => {

        try {

            setIsLoading(true);

            let url = "/umbraco/api/Home/CountryRegistrationsWidget?widgetInstanceId=" + widgetInstanceId;

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    setModuleUrl(response.ModuleUrl);
                    setOperatorsCount(response.OperatorsCount);
                    setCountryRegistrationsCount(response.CountryRegistrationsCount);
                    setTotalCountriesWithActivity(response.TotalCountriesWithActivity);
                    setExpiredIn1YearCount(response.ExpiredIn1YearCount);
                    setExpiredIn1Year(response.ExpiredIn1Year);

                    setIsLoading(false);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                });

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);


    const content = () => {

        try {

            return (<>
                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i> RIMS Registrations
                    </div>
                </div>

                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                    {error ? <div>{error}</div> : <>

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{totalCountriesWithActivity}</span><br /><span>Countries</span></div>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{countryRegistrationsCount}</span><br /><span>Registrations</span></div>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{expiredIn1YearCount}</span><br /><span>Expire in 1 year</span></div>
                            <div style={{ textAlign: "center" }}><span style={{ fontSize: "15pt" }}>{operatorsCount}</span><br /><span>Operators</span></div>
                        </div>
                        <br/>
                        <div>
                            <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                <div style={{ width: "25%" }}>PRODUCT CODE</div>
                                    <div style={{ width: "40%" }}>PRODUCT NAME</div>
                                    <div style={{ width: "20%" }}>COUNTRY</div>
                                <div style={{ width: "15%" }}>EXPIRY DATE</div>
                            </div>
                                {expiredIn1Year.map((product, index) => {

                                    return (
                                        <div key={index} className="widgetDataLine" style={{ display: "flex", flexDirection: "row", }}>
                                            <div style={{ width: "25%" }}><a href={product.ProductUrl}>{product.ProductCode}</a></div>
                                            <div style={{ width: "40%" }}>{product.ProductName}</div>
                                            <div style={{ width: "20%" }}>{product.Country}</div>
                                            <div style={{ width: "15%" }}>{formatDate(product.ExpiryDate)}</div>
                                        </div>
                                    )
                                })}
                        </div>


                        <div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={moduleUrl} className="widget-view-all-button">Open</a></div>
                    </>}

                </>}
            </>)

        }
        catch (ex) {
            return (<>
                <div className="widgetTitle"><i className="fas fa-globe-americas g-mr-8"></i> RIMS Registrations</div>
                <ErrorMessage />
            </>)
        }


    }


    return (
        <Box>
            {content()}
        </Box>
    );
};



const SRGroups = ({ widgetInstanceId, users, widgetInstances }) => {


    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState("/your-medboard/sr-groups/");

    
    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;

    useEffect(() => {

        try {

            setIsLoading(true);

            let url = "/umbraco/api/SystematicReviewApi/Projects?search=&sortBy=Name&sortType=ASCENDING&page=1&tagIds=&showArchived=false&showMineOnly=false&legalManufacturerId=null&=";

            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            fetch(url, requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((response) => {

                    //setModuleUrl(response.ModuleUrl);

                    response = response.map(group => ({
                        Id: group.Id,
                        Title: group.Title,
                        UserId: group.ResponsiblePerson,
                        Deadline: group.Deadline,
                    })).slice(0, 5);
                    
                    setGroups(response);

                    setIsLoading(false);

                })
                .catch((error) => {
                    console.log("Error: " + error)
                })
                .finally(() => {
                });

        }
        catch (ex) {
            console.log(ex);
            setError("An error ocurred loading the widget...");
        }


    }, []);


    const content = () => {

        try {

            return (<>
                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i> SR Groups
                    </div>
                </div>

                {isLoading ? <div>
                    <LoadingSpinnerImage />
                </div> : <>

                    {error ? <div>{error}</div> : <>

                        <div>
                            <div style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #dadada"}}>
                                <div style={{ width: "70%" }}>TITLE</div>
                                <div style={{ width: "15%" }}>RESPONSIBLE</div>
                                <div style={{ width: "15%" }}>DEADLINE</div>
                            </div>
                                {groups.map((group, index) => {

                                    let url = "/your-medboard/systematic-reviews-menu/?groupId=" + group.Id;

                                    return (
                                        <div key={index} className="widgetDataLine" style={{ display: "flex", flexDirection: "row", }}>
                                            <div style={{ width: "70%" }}><a href={url}>{group.Title}</a></div>
                                            <div style={{ width: "15%" }}><FieldTypes.FieldType_User users={users} value={group.UserId} /></div>
                                            <div style={{ width: "15%" }}>{formatDate(group.Deadline)}</div>
                                        </div>
                                    )
                                })}
                        </div>


                        <div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={moduleUrl} className="widget-view-all-button">Open</a></div>
                    </>}

                </>}
            </>)

        }
        catch (ex) {
            return (<>
                <div className="widgetTitle"><i className="fas fa-globe-americas g-mr-8"></i> SR Groups</div>
                <ErrorMessage />
            </>)
        }


    }


    return (
        <Box>
            {content()}
        </Box>
    );
};



const SystematicReviewDetails = ({ widgetInstanceId, area, widgetInstances, setWidgetInstances }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [moduleUrl, setModuleUrl] = useState(null);
    const [systematicReviewUrl, setSystematicReviewUrl] = useState(null);
    const [showConfigMenu, setShowConfigMenu] = useState(false);
    const [systematicReviewsList, setSystematicReviewsList] = useState([]);

    const [chosenSystematicReview, setChosenSystematicReview] = useState(null);
    const [chosenSystematicReviewArea, setChosenSystematicReviewArea] = useState(area);
    const [hasData, setHasData] = useState(false);
    const [isLoadingConfigMenu, setIsLoadingConfigMenu] = useState(false);
    const [widgetInstanceIsActive, setWidgetInstanceIsActive] = useState(true);
    const [instanceName, setInstanceName] = useState("");
    const [currentName, setCurrentName] = useState("");

    const [isSavingConfiguration, setIsSavingConfiguration] = useState(false);
    const [isLoadingSrs, setIsLoadingSrs] = useState(false);
    const [graphData, setGraphData] = useState([]);

    const [trendGraphWeeklyData, setTrendGraphWeeklyData] = useState([]);
    const [trendGraphMonthlyData, setTrendGraphMonthlyData] = useState([]);
    const [trendGraphYearlyData, setTrendGraphYearlyData] = useState([]);
    const [graphPeriod, setGraphPeriod] = useState("monthly");

    const [relevantFullText, setRelevantFullText] = useState(null);
    const [pending, setPending] = useState(null);
    const [openedTasks, setOpenedTasks] = useState(null);
    const [systematicReviewName, setSystematicReviewName] = useState(null);

    
    const icon = widgetInstances.find(i => i.Id == widgetInstanceId)?.Icon ?? null;



    let defaultInstanceName = "Systematic Review Details";

    if (area == 1) defaultInstanceName = "Literature Review";
    if (area == 2) defaultInstanceName = "Regulatory Intelligence";
    if (area == 3) defaultInstanceName = "Market & PMS Review";

    useEffect(() => {

        loadData();

        let currentName = widgetInstances.find(i => i.Id == widgetInstanceId).Name;

        setCurrentName(currentName);
        setInstanceName(currentName);

    }, []);


    useEffect(() => {

        if (!chosenSystematicReviewArea || chosenSystematicReviewArea == "" || chosenSystematicReviewArea == 0)
            return;

        if (systematicReviewsList.length > 0)
            return;
        
            
        let url = "/umbraco/api/SystematicReviewApi/SystematicReviewsAll?area=" + chosenSystematicReviewArea;

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingSrs(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }

                return response.json();
            })
            .then((response) => {

                response.sort((a, b) => a.Title.toLowerCase().localeCompare(b.Title.toLowerCase()));

                setSystematicReviewsList(response);

                setIsLoadingSrs(false);

            })
            .catch((error) => {
                console.log("Error: " + error)
            })
            .finally(() => {
            });


    }, [chosenSystematicReviewArea]);


    const graphOptions = useMemo(() => (
        {
            credits: {
                text: 'www.medboard.com',
                href: 'https://www.medboard.com/'
            },
            chart: {
                type: 'area',
                height: 300,
            }, title: undefined,
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: { // don't display the dummy year
                    //  month: '%e. %b',
                    year: '%b %Y'
                },
                title: {
                    text: 'Date'
                }
            },
            yAxis: {
                title: {
                    text: 'Result Count'
                },
                min: 0
            },
            tooltip: {
                headerFormat: '<b>{series.name}</b><br>',
                pointFormat: '{point.x:%b %Y}: {point.y:f}'
            },

            plotOptions: {
                series: {
                    marker: {
                        enabled: false
                    }
                }
            }, colors: ['#6CF', '#39F', '#06C', '#036', '#000'],
            series: [{
                name: "",
                data: graphData
            }],
            legend: {
                enabled: false
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        plotOptions: {
                            series: {
                                marker: {
                                    radius: 2.5
                                }
                            }
                        }
                    }
                }]
            }
        }
    ), [graphData]);


    const changeGraphPeriod = (period) => {

        setGraphPeriod(period);

        if (period == "weekly") setGraphData(trendGraphWeeklyData);
        if (period == "monthly") setGraphData(trendGraphMonthlyData);
        if (period == "yearly") setGraphData(trendGraphYearlyData);

    }


    const createDatapoints = (data) => {
        var datapoints = [];
        for (var i = 0; i < data.length; i++) {
            var dayData = data[i];
            datapoints.push([Date.UTC(dayData.PeriodMidYear, dayData.PeriodMidMonth - 1, dayData.PeriodMidDay), dayData.HitCount]);
        }
        return datapoints;
    }

 
    const openConfigMenu = () => {

        // Load configuration options (systematic reviews list) from server
        if (isLoadingConfigMenu)
            return;

        let url = "/umbraco/api/Home/WidgetInstanceConfigurations?widgetInstanceId=" + widgetInstanceId;

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoadingConfigMenu(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((response) => {

                let SrConfigurationId = 1;

                let SrConfiguration = response.find(config => config.ConfigurationId == SrConfigurationId);

                let srId = SrConfiguration ? SrConfiguration.Value : null;

                setChosenSystematicReview(srId);

                setShowConfigMenu(true);
            })
            .catch((error) => {
                console.log("Error: " + error)
            })
            .finally(() => {
                setIsLoadingConfigMenu(false);
            });



    }


    const closeConfigMenu = () => {

        // reset instance name
        setInstanceName(currentName);
        setShowConfigMenu(false);
    }


    const chooseSystematicReview = (srId) => {

        setChosenSystematicReview(srId);

        setInstanceName(defaultInstanceName + ": " + systematicReviewsList.find(sr => sr.Id == srId)?.Title ?? defaultInstanceName);

    }



    const saveConfiguration = () => {

        setIsSavingConfiguration(true);

        let instance = widgetInstances.find(i => i.Id == widgetInstanceId);

        instance.Name = instanceName;
        instance.IsActive = true;

        instance.Configurations = [
            { WidgetInstanceId: widgetInstanceId, ConfigurationId: 1, Field: "Systematic Review", Value: chosenSystematicReview},
        ];


        let url = "/umbraco/api/Home/WidgetInstances/";

        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(instance)
        };

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((response) => {

                // Load new data from server
                loadData();

                setWidgetInstances(prev =>
                    prev.map(instance =>
                        instance.Id === widgetInstanceId
                            ? { ...instance, Name: instanceName, IsActive: widgetInstanceIsActive }
                            : instance
                    )
                );

                setShowConfigMenu(false);

            })
            .catch((error) => {
                console.log("Error: " + error)
            })
            .finally(() => {
                setIsSavingConfiguration(false);
                
            });


    }


    const loadData = () => {

        let url = "/umbraco/api/Home/SystematicReviewDetailsWidget?widgetInstanceId=" + widgetInstanceId;

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        setIsLoading(true);

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }

                if (response.status === 204)
                    return null;

                return response.json();
            })
            .then((response) => {

                if (response !== null) {

                    setModuleUrl(response.ModuleUrl);
                    setSystematicReviewUrl(response.SystematicReviewUrl);

                    setPending(response.Pending);
                    setRelevantFullText(response.RelevantFullText);
                    setOpenedTasks(response.OpenTasks);
                    setSystematicReviewName(response.SystematicReviewName);

                    setTrendGraphWeeklyData(createDatapoints(response.TrendGraph.WeeklyDateHits));
                    setTrendGraphYearlyData(createDatapoints(response.TrendGraph.YearlyDateHits));
                    setTrendGraphMonthlyData(createDatapoints(response.TrendGraph.MonthlyDateHits));

                    setGraphData(createDatapoints(response.TrendGraph.MonthlyDateHits));

                    setHasData(true);
                }

            })
            .catch((error) => {
                console.log("Error: " + error)
            })
            .finally(() => {
                setIsLoading(false);
            });

    }


    const content = () => {

        try {

            return (<>
                <div className="widgetTitle">
                    <div style={{flex: 1}}>
                        <i className={icon + " g-mr-8"}></i> {instanceName}
                    </div>
                    <div style={{width: "130px"}}>

                    </div>
                </div>
                
                {isLoading ?
                    <div style={{ textAlign: "center" }}>
                        <LoadingSpinnerImage />
                    </div>
                    :
                    <>

                        {error ? <div>{error}</div> : <>

                            {isLoadingConfigMenu ? <div style={{textAlign: "center"}}><LoadingSpinnerImage /></div> : null}

                            {showConfigMenu ? <>

                                <div className="widgetConfigurationMenu">
                                    <div className="widgetConfigurationMenuContent">

                                        <div style={{display: "flex", marginBottom: "20px"}}>
                                            <div style={{width: "10%"}}></div>
                                            <div style={{ flex: 1, textAlign: "center" }}><h6>Widget Settings</h6></div>
                                            <div style={{ width: "10%", textAlign: "right" }}><button className="close-button" onClick={closeConfigMenu}><i className="fas fa-times"></i></button></div>
                                        </div>


                                        <div style={{ marginBottom: "15px", display: "flex", flexDirection: "row" }}>
                                            <div style={{width: "35%", textAlign: "right"}}>Choose the systematic review:</div>
                                            <div style={{ flex: 1, marginLeft: "15px" }}>
                                                
                                                {isLoadingSrs ? <LoadingSpinnerImage /> : 
                                                    <select style={{maxWidth: "200px"}} value={chosenSystematicReview} onChange={(e) => { chooseSystematicReview(e.target.value); }} >
                                                        <option value="">Choose a Systematic Review</option>
                                                        {
                                                            systematicReviewsList.map((sr) => (
                                                                <option value={sr.Id}>{sr.Title} ({sr.Alias})</option>
                                                            ))
                                                        }
                                                    </select>
                                                }

                                            </div>
                                        </div>

                                        <div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}>
                                            {isSavingConfiguration ? <LoadingSpinnerImage /> :
                                                <button onClick={saveConfiguration} className="action-button save-button">Save</button>
                                            }
                                        </div>

                                    </div>
                                </div>

                            </> : null}


                            {hasData ? <>
                                <div>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                                        
                                        <div title="Pending" className="" style={{ marginLeft: "5px"}} >
                                            <i className="fas fa-circle" style={{ textAlign: 'center', fontSize: '15pt', marginRight: '8px', color: 'rgb(255, 243, 183)', border: '1px solid #e6e6e6', borderRadius: '100px' }}></i>
                                            Pending <span className="appraisal-status-count">{pending}</span>
                                        </div>
                                        <div title="Pending" className="" style={{ marginLeft: "5px" }} >
                                            <i className="fas fa-circle" style={{ textAlign: 'center', fontSize: '15pt', marginRight: '8px', color: 'rgb(56 152 59)', border: '1px solid #e6e6e6', borderRadius: '100px' }}></i>
                                            Relevant <span className="appraisal-status-count">{relevantFullText}</span>
                                        </div>
                                        <div style={{ marginLeft: "5px" }}>
                                            Open Tasks:  <span style={{ marginLeft: "5px", fontSize: "13px", fontWeight: "600", backgroundColor: openedTasks > 0 ? '#ffd5d5' : '#d5f6d5', padding: '2px 8px', borderRadius: "15px"  }}>{openedTasks}</span></div>
                                    </div>
                                    <br/>

                                    <HighchartsReact highcharts={Highcharts} options={graphOptions} />

                                    <div style={{display: "flex", justifyContent: "center"}}>
                                        <div className="btn-group dropup g-mr-10 g-mb-15 center">
                                            <button type="button" onClick={() => changeGraphPeriod("weekly")} className={"btn btn-outline-secondary " + (graphPeriod == "weekly" ? "active" : null)} style={{ fontSize: "0.8rem" }}>Weekly</button>
                                            <button type="button" onClick={() => changeGraphPeriod("monthly")} className={"btn btn-outline-secondary " + (graphPeriod == "monthly" ? "active" : null)} style={{ fontSize: "0.8rem" }}>Monthly</button>
                                            <button type="button" onClick={() => changeGraphPeriod("yearly")} className={"btn btn-outline-secondary " + (graphPeriod == "yearly" ? "active" : null)} style={{ fontSize: "0.8rem" }}>Yearly</button>
                                        </div>
                                    </div>


                                    <div style={{ textAlign: "center", marginTop: "20px", textDecoration: "none" }}><a href={systematicReviewUrl} className="widget-view-all-button">Open</a></div>
                                </div>
                            </> : <>
                                {showConfigMenu || isLoadingConfigMenu ? null : <>

                                        <div style={{display: "flex", justifyContent: "center", cursor: "pointer"}}>
                                            <div className="g-color-blue--hover g-transition-0_2 u-block-hover list-group-item-action text-center g-text-underline--none--hover g-brd-blue--hover"
                                                onClick={openConfigMenu} style={{ cursor: "pointer" }} style={{ width:"60%", textAlign: "center", border: "2px dashed #ccc", borderRadius: "15px", padding: "10px 30px", backgroundColor: "#fafafa" }}>
                                                Select which Systematic Review you can to display in the Widget:
                                                <br /><br />
                                                <span><i className="fas fa-cog g-font-size-15"></i> </span><br /><br />
                                            </div>
                                        </div>

                                </>}
                            </>}


                        
                    </>}

                    </>
                }
            </>)

        }
        catch (ex) {
            return (<>
                <div className="widgetTitle"><i className="fas fa-globe-americas g-mr-8"></i> Systematic Review</div>
                <ErrorMessage />
            </>)
        }

    }

    return (
        <Box>
            {content()}
        </Box>
    );

}














const ErrorMessage = () => {

    return (<>
        <div className="errorLoadingWidget">There was an error loading this widget...</div>
    </>);

}












const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};



const formatDate = (date, showTime = false) => {
    if (!date) return ""; // handles null, undefined, empty string

    const d = new Date(date);
    if (isNaN(d.getTime())) {
        return ""; // still invalid (like "not-a-date")
    }

    const options = {
        month: "short",
        day: "numeric",
        year: "numeric",
    };

    if (showTime) {
        options.hour = "2-digit";
        options.minute = "2-digit";
    }

    return d.toLocaleDateString(undefined, options);
};







const styles = {
    page: {
        fontFamily:
            "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
        background: "#f0f2f5",
        padding: 16,
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #c9ddff 0px, #f0f2f5 250px)",
    },
    appBar: {
        display: "flex",
        alignItems: "initial",
        gap: 12,
        padding: "8px 12px",
        borderRadius: 8,
        marginBottom: 16,
        justifyContent: "center",
        maxWidth: "100%",
        overflow: "auto",
    },
    appIcon: {
        width: 55,
        height: 55,
        borderRadius: 40,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        textDecoration: "none",
        background: "#fff",
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
        transition: "all 0.2s ease"
    },
    manageBtn: {
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: 18,
        padding: 8,
    },
    twoCols: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 16,
    },
    col: {
        display: "flex",
        flexDirection: "column",
        gap: 16,
    },
    modalOverlay: {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
    },
    modal: {
        width: 560,
        maxHeight: "92vh",
        overflow: "auto",
        background: "#fff",
        borderRadius: 10,
        padding: 18,
        boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
    },
    controlRow: {
        display: "flex",
        justifyContent: "flex-end",
        gap: 30,
        marginTop: 12,
    },
    btn: {
        padding: "8px 12px",
        borderRadius: 8,
        border: "1px solid #ddd",
        background: "#fff",
        cursor: "pointer",
    },
    btnPrimary: {
        padding: "8px 12px",
        borderRadius: 8,
        border: "none",
        background: "#2563eb",
        color: "white",
        cursor: "pointer",
    },
    smallInput: {
        padding: 6,
        borderRadius: 6,
        border: "1px solid #ccc",
    },
};


export default Dashboard;